import { FilterProps } from './Filter.types';
import { Wrapper, ButtonStyled } from './Filter.styles';

export const Filter: React.FC<FilterProps> = ({
  className,
  options = [],
  selectedOption = null,
  onSelect,
}) => {
  return (
    <Wrapper className={className}>
      {options.map((option, index) => {
        return (
          <ButtonStyled
            key={`filter-option_${index}`}
            onClick={() => onSelect(option)}
            selected={option.value === selectedOption}
          >
            {option.label}
          </ButtonStyled>
        );
      })}
    </Wrapper>
  );
};
